import { useState } from "react";
import { commentFeed } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function CommentFeed() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (user: string) => {
    setLiked((prev) => ({ ...prev, [user]: !prev[user] }));
  };

  return (
    <section id="comments" className="scroll-mt-20 border-b border-background-300/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="COMMENT FEED"
          title="网友评论速览：密度拉满的短评流"
          desc="挑出讨论区里信息量更大的网友评论，按时间倒序排布，扫一眼就知道当下大家在争什么。"
          aside={
            <span className="inline-flex items-center gap-1.5 rounded-md border border-secondary-200 bg-secondary-100 px-3 py-1.5 font-label text-xs text-secondary-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-chat-smile-2-line text-xs"></i>
              </span>
              共 9,742 条网友评论
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {commentFeed.map((comment) => (
            <article
              key={comment.user}
              className="flex flex-col rounded-lg border border-background-300/70 bg-background-50 p-4"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {comment.user.slice(0, 1)}
                </span>
                <div className="min-w-0">
                  <p className="truncate font-label text-sm font-medium text-foreground-900">{comment.user}</p>
                  <p className="truncate font-label text-xs text-foreground-500">
                    {comment.city} · {comment.time}
                  </p>
                </div>
                <span className="ml-auto shrink-0 rounded bg-secondary-100 px-2 py-0.5 font-label text-xs text-secondary-900">
                  {comment.tag}
                </span>
              </div>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{comment.content}</p>

              <div className="mt-4 flex items-center gap-4 border-t border-background-300/60 pt-3 font-label text-xs text-foreground-500">
                <button
                  type="button"
                  onClick={() => toggleLike(comment.user)}
                  className={`flex cursor-pointer items-center gap-1 transition-colors ${
                    liked[comment.user] ? "text-primary-700" : "hover:text-primary-700"
                  }`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={liked[comment.user] ? "ri-thumb-up-fill text-xs" : "ri-thumb-up-line text-xs"}></i>
                  </span>
                  {comment.likes + (liked[comment.user] ? 1 : 0)}
                </button>
                <span className="flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-chat-3-line text-xs"></i>
                  </span>
                  {comment.replies} 条回复
                </span>
                <span className="ml-auto flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-share-forward-line text-xs"></i>
                  </span>
                  分享
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}